import React from "react";

import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as FaIcons from "react-icons/fa";
import * as BsIcons from "react-icons/bs";

export const SidebarData = [
  {
    title: "Dashboard",
    path: "/ToDoList",
    icon: <IoIcons.IoIosPaper />,
    cName: "nav-text",
  },
  {
    title: "Home",
    path: "/",
    icon: <AiIcons.AiFillHome />,
    cName: "nav-text",
  },
  {
    title: "Prioritize",
    path: "/Prio",
    icon: <FaIcons.FaSortAlphaDown />,
    cName: "nav-text",
  },
  {
    title: "Journals",
    path: "/Journals",
    icon: <BsIcons.BsFillJournalBookmarkFill />,
    cName: "nav-text",
  },
  {
    title: "Calendar",
    path: "/Calendar",
    icon: <AiIcons.AiFillCalendar />,
    cName: "nav-text",
  },
  {
    title: "Flashcards",
    path: "/Flashcards",
    icon: <BsIcons.BsCardText />,
    cName: "nav-text",
  },
  {
    title: "Study Coach",
    path: "/StudyCoach",
    icon: <AiIcons.AiOutlineRobot />,
    cName: "nav-text",
  },
];
